import breakpointsFactory from "@/factories/breakpoints";
import { breakpoints } from "./primitives";

const {
	useIsAbove,
	useIsBelow,
	useBelowHeight,
	createQueryIsAbove,
	createQueryIsBelow,
	createQueryIsBetween,
	createQueryIsBelowHeight,
} = breakpointsFactory(breakpoints);

export const hooks = {
	useIsAbove,
	useIsBelow,
	useBelowHeight,
};
export const queries = {
	isAbove: createQueryIsAbove,
	isBelow: createQueryIsBelow,
	isBetween: createQueryIsBetween,
	isBelowHeight: createQueryIsBelowHeight,
};

export {
	useIsAbove,
	useIsBelow,
	createQueryIsAbove as isAbove,
	createQueryIsBelow as isBelow,
	createQueryIsBetween as isBetween,
};
